import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class OrdenCompraService {

  url = environment.baseUrl+ '/api/OrdenCompra';

  constructor(private http: HttpClient) {}

  getOrdenesCompra(page: number, numReg: number,searchString:string): Observable<any> {
    const body = { page, numReg,searchString };
    console.log('el cuerpo es: ', body)
    return this.http.post<any>(this.url + '/GetOrdenesCompra', body, httpOption);
  }

  addOrdenCompra(obj:any): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/AddOrdenCompra', obj, httpOption);
  }

  editOrdenCompra(obj:any): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/EditOrdenCompra', obj, httpOption);
  }

  deleteOrdenCompra(id:string): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/DeleteOrdenCompra', {id}, httpOption);
  }

  presentarOrdenCompra(id:string): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/PresentarOrdenCompra', {id}, httpOption);
  }

  editarUsuarioOrdenCompra(ordenCompraId:string, usuarioId:string, estado: boolean, planId:string): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/EditarUsuarioOrdenCompra', {ordenCompraId, usuarioId, estado, planId}, httpOption);
  }

  getOrdenesCompraAdminActivas(page: number, numReg: number,searchString:string): Observable<any> {
    const body = { page, numReg,searchString };
    return this.http.post<any>(this.url + '/GetOrdenesCompraAdminActivas', body, httpOption);
  }

  getOrdenesCompraAdminHistorica(obj:any): Observable<any> {
    return this.http.post<any>(this.url + '/GetOrdenesCompraAdminHistorica', obj, httpOption);
  }

  finalizarOrdenCompra(id:string): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/FinalizarOrdenCompra', {id}, httpOption);
  }
  
  abrirOrdenCompra(id:string): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/AbrirOrdenCompra', {id}, httpOption);
  }

  cambiaEstadoDetalleUsuarioEstadoOrden(detalleOrdenId:string, estado:number): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/CambiaEstadoDetalleUsuarioEstadoOrden', {detalleOrdenId, estado}, httpOption);
  }
  
  getValorOrdenCompra(id:string): Observable<number> {
    return this.http.post<number>(this.url + '/GetValorOrdenCompra', {id}, httpOption);
  }

  getValorOrdenCompraAbierta(id:string): Observable<number> {
    return this.http.post<number>(this.url + '/GetValorOrdenCompraAbierta', {id}, httpOption);
  }

  getValorOrdenCompraAdmin(id:string): Observable<number> {
    return this.http.post<number>(this.url + '/GetValorOrdenCompraAdmin', {id}, httpOption);
  }
  
  getValorFinalOrdenCompra(id:string): Observable<number> {
    return this.http.post<number>(this.url + '/GetValorFinalOrdenCompra', {id}, httpOption);
  }

  getComentario(obj:any): Observable<any> {
    return this.http.post<any>(this.url + '/GetComentario', obj, httpOption);
  }
  
  setComentario(obj:any): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/SetComentario', obj, httpOption);
  }

  getDetalleOrdenCompra(id:string): Observable<any> {
    return this.http.post<any>(this.url + '/GetDetalleOrdenCompra', {id}, httpOption);
  }

  getDetalleOrdenCompraAdmin(id:string): Observable<any> {
    return this.http.post<any>(this.url + '/GetDetalleOrdenCompraAdmin', {id}, httpOption);
  }

  rechazarOrdenCompra(id:string): Observable<boolean> {
    return this.http.post<boolean>(this.url + '/RechazarOrdenCompra', {id}, httpOption);
  }

  getOrdenesCompraPorUsuario(obj:any): Observable<any> {
    return this.http.post<any>(this.url + '/GetOrdenesCompraPorUsuario', obj, httpOption);
  }

  validarOrdenCompra(id:string): Observable<any> {
    return this.http.post<any>(this.url + '/ValidarOrdenCompra', {id}, httpOption);
  }

  getOrdenCompraPdf(id:string): Observable<Blob> {
    return this.http.post<Blob>(this.url+'/GetOrdenCompraPdf',{id}, {responseType: 'blob' as 'json'});

  }
  
}
